import Product from './Product';

/**
 * 
 */
class Media extends Product {
   constructor(ipNumber, isbn, category, title, subtitle, description, author, subject, priceCad, priceUsd, image, performers, number, totalTime, tracks, language, type) {
      super(ipNumber, isbn, title, category, priceCad, priceUsd, type);
      this.subtitle = subtitle;
      this.description = description;
      this.author = author;
      this.subject = subject;
      this.image = image
      this.performers = performers;
      this.number = number;
      this.totalTime = totalTime;
      this.tracks = tracks;
      this.language = language;
   }


   getDbPath() {
      return this.type + 's/' + this.isbn
   }


   getStoragePrefix() {
      if (this.type === 'cassette') {
         return 'cds/';
      }
      return this.type + 's/';
   }
}

export default Media;